import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import type { Lead, MergeLeadDto } from '@/types/lead';

export interface MergeLeadVariables extends MergeLeadDto {
  survivorLeadId: string;
}

export function useMergeLead() {
  const queryClient = useQueryClient();

  return useApiMutation<Lead, MergeLeadVariables>({
    mutationFn: ({ survivorLeadId, ...dto }) =>
      apiPost<Lead, MergeLeadDto>(operationsClient, leadEndpoints.merge(survivorLeadId), dto),
    onSuccess: (_data, { survivorLeadId, duplicateLeadId }) => {
      // Invalidate (don't cache the mutation response): only GET /leads/:id
      // resolves departed-owner assignment names (NOT-486).
      void queryClient.invalidateQueries({
        queryKey: leadKeys.detail(survivorLeadId),
        exact: false,
      });
      void queryClient.invalidateQueries({
        queryKey: leadKeys.detail(duplicateLeadId),
        exact: false,
      });
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Leads merged');
    },
  });
}
